module.exports = __webpack_public_path__ + "media/images/logo-no-txt-bf7ed297d318c13817162cabc07dfaa6.svg";